import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";
import { withApollo } from 'react-apollo';
import CatalogItems from "./components/CatalogItems";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Tour from './Tour'
import { signout } from '../../../redux/actions/userActions';
import TourNotActive from '../TourNotActive';
import EndTour from './EndTour';

class TourTraining extends Component {
  state = {
    trainingType: "security"
  };

  render() {
    const {toggleTour} = this.props;
    return (
      <Container>
        {toggleTour.toggleOn ?
          <Container>  
          {toggleTour.isCloseTourButtonClicked ? null : <Tour/>}
          <Row>
            <Col md={12}>
              <h3 className="page-title">Security Training</h3>
  
              <h3 className="page-subhead subhead">
                Build your Security awareness by watching these short 
                and interesting videos. To ensure that you adhere to your 
                organization’s policies and earn some cool certificates, 
                make sure you take the corresponding quiz.
              </h3>
            </Col>
          </Row>
          <Row>
            <CatalogItems active={this.state.trainingType} />
          </Row>
          <EndTour modal={toggleTour.endTourModal}/>
          </Container>
        : <TourNotActive/>}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
      user: state.auth.user,
      settings: state.auth.settings,
      toggleTour: state.toggleTour
  }
}

export default connect(mapStateToProps, { signout })(withRouter(withApollo(TourTraining)));



// WEBPACK FOOTER //
// ./src/components/tour/training/TourTraining.js